import axios from "@/api/axios";

class ActivityLogService {
  async getActivityLogs(params = {}) {
    return await axios.get("/activity-logs", { params });
  }

  async getModerators() {
    return await axios.get("/moderators");
  }

  async getModeratorActivities(id, params = {}) {
    return await axios.get(`/moderators/${id}/activities`, {
      params,
    });
  }

  async getModeratorStatistics(id) {
    return await axios.get(`/moderators/${id}/statistics`);
  }

  async getModerator(id) {
    return await axios.get(`/moderators/${id}`);
  }

  async toggleModeratorActive(id) {
    return await axios.post(`/moderators/${id}/toggle-active`);
  }

  async deleteModerator(id) {
    return await axios.delete(`/moderators/${id}`);
  }

  async getModeratorLeadReassignmentPreview(id) {
    return await axios.get(`/moderators/${id}/lead-reassignment-preview`);
  }

  async reassignModeratorLeads(id) {
    return await axios.post(`/moderators/${id}/reassign-leads`);
  }

  async getModeratorUserReassignmentPreview(id) {
    return await axios.get(`/moderators/${id}/user-reassignment-preview`);
  }

  async reassignModeratorUsers(id) {
    return await axios.post(`/moderators/${id}/reassign-users`);
  }

  async updateModeratorPassword(id, data) {
    return await axios.put(`/moderators/${id}/password`, data);
  }

  // async getMeta() {
  //     return await axios.get("/admin/activity-logs/meta");
  // }
}

export default new ActivityLogService();
